export function useIsTouchscreen() {
  return 'ontouchstart' in window
}
